<template>
  <div>
    <v-card style="border: 1px solid #666666;">
      <v-card-text>
        <v-container fluid grid-list-xs >
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="txtPcbName"
                label="PCB Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs5>
              <div :style="`position:relative;width:350px;height:` + (350 / pcb.image.originalWidth) * pcb.image.originalHeight + `px;background-image: url('` + pcb.image.largeUrl + `');background-size:contain;`">
                <div v-for="(area, index) in this.areas" :key="index"
                  style="cursor:pointer;"
                  :style="'background-color:' + (area.componentIndex === componentIndex ? 'red' : 'darkred') + ';position:absolute;top:' + area.y + '%;left:' + area.x + '%;width:' + area.width + '%;height:' + area.height + '%;'"
                  @click="selectComponent(area.componentIndex)"
                >
                </div>
              </div>
            </v-flex>
            <v-flex xs7>
              <v-card v-for="(component, index) in pcb.components" :key="index" class="mb-3" style="cursor:pointer;" :style="componentIndex === index ? 'border: 1px solid orange;' : 'border: 1px solid #666666;'" @click="selectComponent(index)">
                <v-card-text>
                  <h2>
                    {{ component.name }}
                    <v-btn icon small @click="$refs.schematicComponent.show(index)"><v-icon small>edit</v-icon></v-btn>
                  </h2>
                  <div class="mt-3">
                    <h2 class="subheading font-weight-bold">Products</h2>
                    <v-container fluid grid-list-xs >
                      <v-layout row wrap v-for="(item, itemIndex) in component.products" :key="item.productId">
                        <v-flex xs4>
                          <img v-if="item.image" :src="item.image.mediumUrl" class="item-thumb">
                          <div v-else style="width:100%; height: 70px; border: 1px solid #ababab; padding: 15px 10px;">No Image</div>
                        </v-flex>
                        <v-flex xs8>
                          <a :href="item.url" class="white--text" target="_blank">{{ item.name }}</a>
                          <div class="subheading mt-3 font-weight-bold">${{ formatPrice(item.retailPriceInBase) }}</div>
                          <div class="caption">Unit weight: {{ formatPrice(item.weight) }} kg</div>
                          <div>
                            <v-btn
                              outline
                              small
                              @click="deleteProduct(index, itemIndex)"
                            >
                              Remove
                            </v-btn>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-btn outline small @click="$refs.productSelector.show({ componentIndex: index })">Add product</v-btn>
                  </div>
                </v-card-text>
              </v-card>
              <v-btn
                outline
                class="mt-4"
                @click="$refs.schematicComponent.show()"
              >
                Add Component
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <schematic-component ref="schematicComponent" :pcb="pcb" @finished="onComponentFinished"></schematic-component>
    <product-selector ref="productSelector" currencyCode="USD" :exchangeRateToBase="1" mode="product" @product-added="onProductAdded"></product-selector>
  </div>
</template>

<style scoped>
.context-menu {
  border: 1px solid #fff;
  background-color: #333333;
  padding: 10px;
  position: fixed;
}

.item-thumb {
  width: 100%;
  min-width: 60px;
  height: auto;
  border: 1px solid #dedede;
}

</style>

<script>
import SchematicComponent from '@/components/SchematicComponent.vue'
import ProductSelector from '@/components/ProductSelector.vue'

export default {
  props: {
    pcb: {
      required: true,
      type: Object
    }
  },
  components: {
    SchematicComponent,
    ProductSelector
  },
  data () {
    return {
      def: this.$store.getters.getDef,
      areas: [],
      componentIndex: null,
      txtPcbName: ''
    }
  },
  computed: {
    deliveryButtonCaption: function () {
      if (this.deliveryStatus === 'pending' || this.deliveryStatus === 'partial') {
        return 'Ship'
      } else {
        return 'View'
      }
    }
  },
  watch: {
    pcb: {
      // This will let Vue know to look inside the array
      deep: true,

      // Will fire as soon as the component is created
      immediate: true,

      // We have to move our method to a handler field
      handler: function (val, oldVal) {
        console.log('pcb data updated')
        this.txtPcbName = this.pcb.name
        this.refreshAreas()
      }
    }
  },
  methods: {
    selectComponent: function (componentIndex) {
      // let components = this.pcb.components.map((x) => x)
      // for (let i in components) {
      //   if (i === componentIndex) {
      //     components[i].isSelected = true
      //   } else {
      //     components[i].isSelected = false
      //   }
      // }
      // this.pcb.components = components
      if (this.componentIndex === componentIndex) {
        this.componentIndex = null
      } else {
        this.componentIndex = componentIndex
      }
    },
    refreshAreas: function () {
      console.log('refreshAreas')
      let areas = []
      for (let i in this.pcb.components) {
        for (let j in this.pcb.components[i].areas) {
          this.pcb.components[i].areas[j].componentIndex = Number(i)
          areas.push(this.pcb.components[i].areas[j])
        }
      }
      this.areas = areas
      console.log('schematicPcb refreshAreas', this.areas)
    },
    deleteProduct: function (componentIndex, itemIndex) {
      let components = this.pcb.components.map((x) => x)
      components[componentIndex].products.splice(itemIndex, 1)
      this.pcb.components = components
    },
    onProductAdded: function (product) {
      console.log('onProductAdded', product)
      product.weight = product.unitWeight
      product.retailPriceInBase = product.unitPriceInBase
      product.image = {
        mediumUrl: product.image
      }
      const componentIndex = product.customData.componentIndex
      delete product.customData

      let components = this.pcb.components.map((x) => x)
      components[componentIndex].products.push(product)
      this.pcb.components = components
    },
    onComponentFinished: function (areas, componentIndex, name) {
      console.log('onComponentFinished', areas, componentIndex, name)
      if (componentIndex === null) {
        let newComponent = {
          id: '',
          name,
          // isSelected: false,
          areas: [],
          products: []
        }
        for (let i in areas) {
          newComponent.areas.push(areas[i])
        }
        this.pcb.components.push(newComponent)
      } else {
        let tmpAreas = []
        for (let i in areas) {
          tmpAreas.push(areas[i])
        }

        let components = this.pcb.components.map((x) => x)
        components[componentIndex].areas = tmpAreas
        components[componentIndex].name = name
        this.pcb.components = components
      }
      this.refreshAreas()
    },
    point: function (x, y) {
      return { x, y }
    }
  }
}

</script>
